import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../styles/ModernRomance.css';

const ModernRomance = ({ isPreview = true }) => {
  const { coupleNames } = useParams();
  const [isRevealed, setIsRevealed] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [rsvpData, setRsvpData] = useState({
    name: '',
    attending: '',
    guests: '1',
    message: ''
  });

  // Parse couple names
  const formatCoupleNames = (names) => {
    if (!names) return 'Bride & Groom';
    return names
      .split('-')
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' & ');
  };

  const invitationData = {
    coupleNames: formatCoupleNames(coupleNames),
    groomName: coupleNames?.split('-')[0]?.charAt(0).toUpperCase() + coupleNames?.split('-')[0]?.slice(1).toLowerCase() || 'Michael',
    brideName: coupleNames?.split('-')[1]?.charAt(0).toUpperCase() + coupleNames?.split('-')[1]?.slice(1).toLowerCase() || 'Sarah',
    weddingDate: 'April 20, 2026',
    weddingDay: 'Saturday',
    ceremonyTime: '4:00 PM',
    churchName: 'The Glass Garden Chapel',
    churchAddress: 'Tagaytay City',
    receptionVenue: 'Sonya\'s Garden',
    receptionAddress: 'Alfonso, Cavite',
    message: 'We invite you to celebrate the beginning of our forever.',
    dressCode: 'Semi-Formal',
    colors: 'Blush & Burgundy'
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsRevealed(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="modern-romance">
      {/* Animated Background */}
      <div className="animated-bg">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      {/* Main Content */}
      <div className={`modern-container ${isRevealed ? 'revealed' : ''}`}>
        {/* Navigation */}
        <nav className="modern-nav">
          <button 
            className={activeSection === 'home' ? 'active' : ''} 
            onClick={() => setActiveSection('home')}
          >
            Home
          </button>
          <button 
            className={activeSection === 'details' ? 'active' : ''} 
            onClick={() => setActiveSection('details')}
          >
            Details
          </button>
          <button 
            className={activeSection === 'rsvp' ? 'active' : ''} 
            onClick={() => setActiveSection('rsvp')}
          >
            RSVP
          </button>
        </nav>

        {/* Home Section */}
        {activeSection === 'home' && (
          <section className="modern-section home-section">
            <div className="home-content">
              <p className="save-the-date">Save the Date</p>
              
              <div className="couple-names">
                <span className="name">{invitationData.groomName}</span>
                <span className="heart-icon">♥</span>
                <span className="name">{invitationData.brideName}</span>
              </div>

              <div className="modern-divider">
                <span className="line"></span>
                <span className="diamond">◇</span>
                <span className="line"></span>
              </div>

              <p className="invitation-text">{invitationData.message}</p>

              <div className="wedding-date-display">
                <div className="date-box">
                  <span className="date-number">20</span>
                  <span className="date-month">April</span>
                  <span className="date-year">2026</span>
                </div>
                <div className="date-info">
                  <span className="day">{invitationData.weddingDay}</span>
                  <span className="time">{invitationData.ceremonyTime}</span>
                </div>
              </div>

              <button 
                className="view-details-btn"
                onClick={() => setActiveSection('details')}
              >
                View Details
              </button>
            </div>
          </section>
        )}

        {/* Details Section */}
        {activeSection === 'details' && (
          <section className="modern-section details-section">
            <h2 className="section-title">Wedding Details</h2>

            <div className="details-grid">
              <div className="detail-card">
                <div className="detail-icon">💒</div>
                <h3>Ceremony</h3>
                <p className="venue-name">{invitationData.churchName}</p>
                <p className="venue-address">{invitationData.churchAddress}</p>
                <p className="venue-time">{invitationData.ceremonyTime}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🍾</div>
                <h3>Reception</h3>
                <p className="venue-name">{invitationData.receptionVenue}</p>
                <p className="venue-address">{invitationData.receptionAddress}</p>
                <p className="venue-time">After the ceremony</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">👗</div>
                <h3>Dress Code</h3>
                <p className="dress-info">{invitationData.dressCode}</p>
                <p className="color-info">Colors: {invitationData.colors}</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">💕</div>
                <h3>Gift Guide</h3>
                <p className="gift-message">Your presence means everything.</p>
                <p className="gift-note">Monetary gifts are welcome.</p>
              </div>
            </div>

            <div className="countdown-section">
              <h3>Counting Down</h3>
              <div className="countdown-display">
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Days</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Hours</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Mins</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number">--</span>
                  <span className="countdown-label">Secs</span>
                </div>
              </div>
            </div>

            <button 
              className="rsvp-cta-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              RSVP Now
            </button>
          </section>
        )}

        {/* RSVP Section */}
        {activeSection === 'rsvp' && (
          <section className="modern-section rsvp-section">
            <h2 className="section-title">RSVP</h2>

            <form className="modern-rsvp-form" onSubmit={(e) => e.preventDefault()}>
              <p className="rsvp-intro">Join us in celebrating our love!</p>
              <p className="rsvp-deadline">Please respond by March 20, 2026</p>

              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={rsvpData.name}
                  placeholder="Your name"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>Will you attend?</label>
                <div className="attendance-options">
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="yes"
                      disabled={isPreview}
                    />
                    <span className="option-icon">✓</span>
                    <span className="option-text">Yes, I'll be there!</span>
                  </label>
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="no"
                      disabled={isPreview}
                    />
                    <span className="option-icon">✗</span>
                    <span className="option-text">Sorry, can't make it</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Number of Guests</label>
                <select
                  name="guests"
                  value={rsvpData.guests}
                  disabled={isPreview}
                >
                  <option value="1">1 Guest</option>
                  <option value="2">2 Guests</option>
                  <option value="3">3 Guests</option>
                  <option value="4">4 Guests</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message (Optional)</label>
                <textarea
                  name="message"
                  value={rsvpData.message}
                  placeholder="Send your wishes..."
                  rows="3"
                  disabled={isPreview}
                />
              </div>

              <button type="submit" className="submit-rsvp-btn" disabled={isPreview}>
                Send RSVP
              </button>
            </form>
          </section>
        )}

        {/* Watermark */}
        <div className="modern-watermark">
          <a href="/invitations" className="back-to-templates-btn">Back to Designs</a>
          <p>Created with ♥ by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Logica Technology</a></p>
        </div>
      </div>
    </div>
  );
};

export default ModernRomance;
